import { Container, Stack, useTheme } from "@mui/material";
import React from "react";
import Details from "./Details";
import ProductDetailsComment from "./ProductDetailsComment";
import { useParams } from "react-router-dom";
import { useGetProductsQuery } from "../../../Store/Slices/rtk";
import SeoHelmet from "../../../Components/SeoHelmet";

export default function ProductDetails() {
  const theme = useTheme();
  const { productCode, variantId } = useParams();

  const { data } = useGetProductsQuery(`?code=${productCode}`);
  const orgData = data?.data?.[0];

  // SEO Configuration
  const seo = orgData?.SEO;
  const defaultTitle = orgData?.title
    ? `${orgData.title} - نیموبایل`
    : "نیموبایل | خرید موبایل، لوازم جانبی و گجت با بهترین قیمت";
  const defaultDescription =
    "در نیموبایل انواع گوشی موبایل، لوازم جانبی، هندزفری، شارژر و گجت‌های هوشمند را با بهترین قیمت، ضمانت اصالت و ارسال سریع خریداری کنید.";
  const defaultKeywords =
    "نیموبایل, خرید موبایل, قیمت گوشی, فروش گوشی موبایل, لوازم جانبی موبایل, خرید هندزفری, خرید شارژر, فروشگاه موبایل";
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";

  const productCoverImage = orgData?.image?.[0]?.file_name
    ? `${import.meta.env.VITE_URL}${orgData.image[0].file_name}`
    : undefined;

  const finalOgImage = seo?.og_image?.file_name
    ? `${import.meta.env.VITE_URL}${seo.og_image.file_name}`
    : productCoverImage;

  return (
    <>
      <SeoHelmet
        title={defaultTitle}
        metaTitle={seo?.meta_title || defaultTitle}
        metaDescription={seo?.meta_description || defaultDescription}
        metaKeywords={seo?.meta_keywords || defaultKeywords}
        index={seo?.index !== undefined ? seo.index : true}
        follow={seo?.follow !== undefined ? seo.follow : true}
        ogTitle={seo?.og_title || seo?.meta_title || defaultTitle}
        ogDescription={
          seo?.og_description || seo?.meta_description || defaultDescription
        }
        ogType={seo?.og_type || "product"}
        ogUrl={seo?.og_url || currentUrl}
        ogImage={finalOgImage}
        twitterTitle={
          seo?.twitter?.twitter_title || seo?.meta_title || defaultTitle
        }
        twitterDescription={
          seo?.twitter?.twitter_description ||
          seo?.meta_description ||
          defaultDescription
        }
        twitterCard={seo?.twitter?.twitter_card || "summary_large_image"}
        twitterImage={finalOgImage}
        scheme={seo?.json_schema}
      />
      <Container maxWidth={"xxl"}>
        <Details varId={variantId} data={data} />
        <ProductDetailsComment varCode={variantId} prCode={productCode} />
      </Container>
    </>
  );
}
